var path = 'src/app/forms/label.html';
var html = "<label class=control-label ng-class=\"{'col-md-3': horizontal}\" ng-transclude></label> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/label.html
 ** module id = 332
 ** module chunks = 0
 **/